import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import { generateIdRoutePath } from '../../../helpers';
const CannotEditRally = ({ rallyId }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const linkParentRef = useRef(null);
    const closeModal = () => {
        setTimeout(() => {
            dispatch(setIsModalOpen(false));
            dispatch(setModalContent(null));
        }, 200);
    };
    useEffect(() => {
        if (linkParentRef.current) {
            const link = linkParentRef.current.querySelector('a');
            if (link) {
                link.addEventListener('click', closeModal);
                return () => link.removeEventListener('click', closeModal, false);
            }
        }
    }, [linkParentRef.current]);
    return (_jsxs("div", { className: 'modal-content cannot-edit-rally', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.editing_is_disabled'), type: 'h1' }) }), _jsx("div", { className: "modal-content-description", ref: linkParentRef, children: _jsx(Trans, { i18nKey: "admin.cannot_edit_rally", components: [_jsx("a", { href: generateIdRoutePath(APP_ROUTES.adminRallySessions, rallyId) })] }) }), _jsx("div", { className: "modal-content-button", children: _jsx(ButtonsGroup, { justify: 'center', children: _jsx(Button, { label: t('button.cancel'), onClick: () => {
                            dispatch(setIsModalOpen(false));
                            dispatch(setModalContent(null));
                        } }) }) })] }));
};
export default CannotEditRally;
